module.exports = __webpack_public_path__ + "8cdea673fc81e8b3f0154e9774ae137d.pdf";